export enum EmployeeSortFieldEnum {
    CREATED_AT = 'CREATED_AT',
    FIRST_NAME = 'FIRST_NAME',
    EMAIL = 'EMAIL',
    LAST_NAME = 'LAST_NAME',
}

export enum ConsumptionPaymentMode {
    COMPANY = 'COMPANY',
    EMPLOYEE = 'EMPLOYEE',
}